import React from 'react';
import './style.scss';
import '../common.scss';
import { useNavigate } from 'react-router-dom';
import Button from '../../../controls/button';

const GeneralView = () => {
  const navigate = useNavigate();

  const switchToBuy = () => {
    navigate('/creamshop/buy');
  };

  const switchToSell = () => {
    navigate('/creamshop/sell');
  };

  return (
    <div className='creamshop-view creamshop-general'>
      <h1 className='creamshop-view-title'>IRASSHAIMASE!</h1>
      <p className='creamshop-general-desc body-2'>
        Welcome to the hand cream shop. Would you like to trade some $cream?
      </p>
      <div className='creamshop-general-buttons'>
        <Button color='primary' onClick={switchToBuy}>
          Buy
        </Button>
        <Button color='secondary' onClick={switchToSell}>
          Sell
        </Button>
      </div>
    </div>
  );
};

export default GeneralView;
